import { render, staticRenderFns } from "./DeliverablesSelectorPopup.view.vue?vue&type=template&id=70d64f28&"
import script from "./DeliverablesSelectorPopup.view.vue?vue&type=script&lang=js&"
export * from "./DeliverablesSelectorPopup.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d64f28')) {
      api.createRecord('70d64f28', component.options)
    } else {
      api.reload('70d64f28', component.options)
    }
    module.hot.accept("./DeliverablesSelectorPopup.view.vue?vue&type=template&id=70d64f28&", function () {
      api.rerender('70d64f28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/deliverables/DeliverablesSelectorPopup.view.vue"
export default component.exports